// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.object("BattlePassSeason", {
  id: __t.u32(),
  name: __t.string(),
  description: __t.string(),
  startsAt: __t.u64(),
  endsAt: __t.u64(),
  maxTier: __t.u32(),
  xpPerTier: __t.u64(),
  premiumPriceCoins: __t.i64(),
  isActive: __t.bool(),
});


